import { Component, EventEmitter, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';

@Component({
  selector: 'app-rendition-movement-delete-all',
  templateUrl: './rendition-movement-delete-all.component.html',
  styleUrls: ['./rendition-movement-delete-all.component.scss'],
})
export class RenditionMovementDeleteAllComponent {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: string | undefined;

  readonly ICON_WARNING = Constants.ICONS.WARNING;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;
}
